class RateLimiter {
    constructor(maxAttempts = 5, timeWindow = 300000) { // 5 minutes window
        this.maxAttempts = maxAttempts;
        this.timeWindow = timeWindow;
        this.attempts = new Map();
    }

    isRateLimited(key) {
        const now = Date.now();
        const userAttempts = this.attempts.get(key) || [];
        
        // Remove attempts outside the time window
        const recentAttempts = userAttempts.filter(timestamp => 
            now - timestamp < this.timeWindow
        );

        // Update attempts
        this.attempts.set(key, recentAttempts);

        // Check if rate limited
        if (recentAttempts.length >= this.maxAttempts) {
            const oldestAttempt = recentAttempts[0];
            const timeRemaining = Math.ceil((oldestAttempt + this.timeWindow - now) / 1000);
            return {
                limited: true,
                timeRemaining
            };
        }

        // Add new attempt
        recentAttempts.push(now);
        this.attempts.set(key, recentAttempts);

        return {
            limited: false,
            timeRemaining: 0
        };
    }

    reset(key) {
        this.attempts.delete(key);
    }
}

export const loginRateLimiter = new RateLimiter();
export const signupRateLimiter = new RateLimiter();
